export default "__VITE_ASSET__DAqYn3sY__"